export default {"src":"/_next/static/media/candleicon.e6c45c91.svg","height":21,"width":23};